// Utility for fetching blob storage images and converting to data URLs
// Used by both ProImages and StopImagesDialog

export const FILE_TYPES = {
  IMAGE: 'data:image/png;base64,',
  PDF: '', // Empty string for PDF - blobData is used directly
};

export interface ImageURLWithKey {
  key: string | number;
  url: string;
}

export interface FetchedBlobImage {
  key: string | number;
  blobData: string;
}

// Fetches blob storage URLs and returns base64 data
export const downloadBlobDataByURLs = async (
  imageURLs: ImageURLWithKey[]
): Promise<FetchedBlobImage[]> => {
  return Promise.all(
    imageURLs.map((eachImageURL, index) =>
      fetch(eachImageURL.url).then(async (res) => {
        if (res.status === 200) {
          return {
            key: eachImageURL?.key ?? index,
            blobData: await res.text(),
          };
        } else {
          throw new Error("file load error");
        }
      })
    )
  );
};
